import { apiIsomorphicFetchUserEnvironment } from '#/api/userEnvironment/apiFetchUserEnvironment';
import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { idealistRequireAuthentication } from '#/modules/auth/routing/idealist-require-authentication';
import { userDashboardCreateEventRoute } from '#/modules/userDashboard/routing/userDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { UserDashboardCreateEventPageLoadable } from './UserDashboardCreateEventPageLoadable';

export const handle = {
  variant: 'base',
  darkBackground: true,
} satisfies LayoutHandleProps;

export async function loader({
  request,
  context,
}: HorizonAppRouteLoaderArgs<typeof userDashboardCreateEventRoute>) {
  const [{ user }] = await Promise.all([
    apiIsomorphicFetchUserEnvironment({
      request,
      context,
    })(),
    UserDashboardCreateEventPageLoadable.load(),
  ]);

  if (!user) return idealistRequireAuthentication({ request, context });
}

export default function UserDashboardCreateEventHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Create an Event')}>
      <UserDashboardCreateEventPageLoadable />
    </RouteModule>
  );
}
